(function () {
    "use strict";

    angular.module("app").factory("habilDate", HabilDateFactory);

    function HabilDateFactory() {
        return {
            // Tests
            IsValidToday: isValidToday,
            IsInvalidInXMonths: isInvalidInXMonths,
            // Utilities
            GetDateOnly: getDateOnly,
            AddMonths: addMonthsUtil,
            SubtractMonths: subtractMonthsUtil,
            AddYears: addYearsUtil,
            SubtractYears: subtractYearsUtil,
        };

        function isValidToday(date) {
            if (!date)
                return false;

            const expirationDate = getDateOnly(date);
            const today = getToday();

            return expirationDate.valueOf() >= today.valueOf();
        }

        function isInvalidInXMonths(date, months) {
            if (!date)
                return false;
            if (!months || isNaN(parseInt(months)))
                return false;

            const monthsInt = parseInt(months);
            const expirationDate = getDateOnly(date);
            const todayPlusMonths = addMonths(getToday(), monthsInt);

            return expirationDate.valueOf() < todayPlusMonths.valueOf();
        }

        function addMonths(date, months) {
            const d = date.getDate();
            date.setMonth(date.getMonth() + +months);
            if (date.getDate() != d) {
                date.setDate(0);
            }
            return date;
        }
                
        function getDateOnly(input) {
            if (!input)
                throw new Error("GetDateOnly: input parameter is required");

            const date = new Date(input);
            date.setHours(0, 0, 0, 0);
            return date;
        }

        function addMonthsUtil(date, months) {
            if (!(date instanceof Date))
                return date;

            if (Number.isNaN(months)) {
                console.error("invalid number of months provided");
                return date;
            }

            if (months <= 0) {
                console.error("At least 1 month needs to be added");
                return date;
            }

            const dateCopy = new Date(date);

            dateCopy.setMonth(dateCopy.getMonth() + months);
            return dateCopy;
        }

        function subtractMonthsUtil(date, months) {
            if (!(date instanceof Date))
                return date;

            if (Number.isNaN(months)) {
                console.error("invalid number of months provided");
                return date;
            }

            if (months <= 0) {
                console.error("At least 1 month needs to be subtracted");
                return date;
            }

            const dateCopy = new Date(date);

            dateCopy.setMonth(dateCopy.getMonth() - months);
            return dateCopy;
        }

        function addYearsUtil(date, years) {
            if (!(date instanceof Date))
                return date;

            if (Number.isNaN(years)) {
                console.error("invalid number of years provided");
                return date;
            }

            if (years <= 0) {
                console.error("At least 1 year needs to be added");
                return date;
            }

            const dateCopy = new Date(date);

            dateCopy.setFullYear(dateCopy.getFullYear() + years);
            return dateCopy;
        }

        function subtractYearsUtil(date, years) {
            if (!(date instanceof Date))
                return date;

            if (Number.isNaN(years)) {
                console.error("invalid number of years provided");
                return date;
            }

            if (years <= 0) {
                console.error("At least 1 year needs to be subtracted");
                return date;
            }

            const dateCopy = new Date(date);

            dateCopy.setFullYear(dateCopy.getFullYear() - years);
            return dateCopy;
        }

        function getToday() {
            const date = new Date();
            return getDateOnly(date);
        }
    }
})();